import React from 'react';
import Button from '../Button';

function ControlButton(props) {
  return (
    <Button {...props} onClick={() => props.onClick()}>
      {props.children}
    </Button>
  );
}

export default ControlButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/ControlButton/ControlButton.jsx